import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Es un libro físico o digital?',
  a: 'Es 100% digital, en formato PDF. Lo descargas y lo guardas en tu celular, tablet o computadora para consultarlo cuando lo necesites.'
}, {
  q: '¿Cuándo lo recibo?',
  a: 'El acceso es inmediato. Apenas se confirma el pago recibes el enlace de descarga en tu correo.'
}, {
  q: '¿Necesito conocimientos previos sobre hierbas o medicina natural?',
  a: 'No. Todo está explicado paso a paso, con ingredientes comunes y un lenguaje claro y simple.'
}, {
  q: '¿Puedo usarlo desde el celular?',
  a: 'Sí. Funciona en celular, tablet y computadora. Una vez descargado, puedes consultarlo sin conexión a internet.'
}, {
  q: '¿Es difícil conseguir los ingredientes?',
  a: 'La mayoría son ingredientes comunes que ya tienes en casa o se consiguen fácil en cualquier tienda naturista o supermercado.'
}, {
  q: '¿Reemplaza la consulta con un profesional de la salud?',
  a: 'No. La guía es material educativo e informativo sobre bienestar natural y soluciones tradicionales. No reemplaza el consejo, diagnóstico ni tratamiento de un profesional. Ante cualquier síntoma persistente, siempre consulta con un médico.'
}, {
  q: '¿Sirve para toda la familia?',
  a: 'Sí. Las recetas están pensadas para distintas edades y situaciones del hogar. Además, incluye un bono específico para niños.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-8 md:py-12 px-5 bg-cream-50" data-id="element-80">
      <div className="max-w-3xl mx-auto" data-id="element-81">
        <div className="text-center mb-8 md:mb-12" data-id="element-82">
          <p className="text-xs uppercase tracking-[0.2em] text-olive-600 font-medium mb-4" data-id="element-83">
            Preguntas frecuentes
          </p>
          <h2 className="font-serif font-medium text-3xl md:text-4xl text-ink-900 leading-tight" data-id="element-84">
            Todo lo que necesitas saber
          </h2>
        </div>

        <div className="space-y-3" data-id="element-85">
          {faqs.map((faq, idx) => {
          const isOpen = openIdx === idx;
          return <div key={idx} className={`bg-cream-100 border rounded-2xl overflow-hidden transition-all ${isOpen ? 'border-olive-300' : 'border-cream-300'}`} data-id="element-86">
                <button onClick={() => setOpenIdx(isOpen ? null : idx)} className="w-full text-left px-5 md:px-6 py-4 md:py-5 flex items-start justify-between gap-4 hover:bg-cream-200/40 transition-colors" aria-expanded={isOpen} data-id="element-87">
                  <h3 className="font-serif font-medium text-base md:text-lg text-ink-900 leading-snug flex-1" data-id="element-88">
                    {faq.q}
                  </h3>
                  <div className="flex-shrink-0 mt-1" data-id="element-89">
                    {isOpen ? <Minus className="w-5 h-5 text-olive-600" data-id="element-90" /> : <Plus className="w-5 h-5 text-olive-600" data-id="element-91" />}
                  </div>
                </button>
                {isOpen && <div className="px-5 md:px-6 pb-5 md:pb-6 -mt-1" data-id="element-92">
                    <p className="text-ink-700 text-sm md:text-base leading-relaxed" data-id="element-93">
                      {faq.a}
                    </p>
                  </div>}
              </div>;
        })}
        </div>

        {/* Disclaimer */}
        <div className="mt-8 md:mt-12 bg-cream-100 border border-cream-300 rounded-2xl p-5 md:p-6 text-center" data-id="element-94">
          <p className="text-xs md:text-sm text-ink-600 leading-relaxed" data-id="element-95">
            <span className="font-medium text-ink-800" data-id="element-96">Aviso importante: </span>
            Esta guía es material educativo e informativo sobre bienestar
            natural. No reemplaza el consejo médico profesional. Ante cualquier
            síntoma persistente, consulta siempre con un profesional de la
            salud.
          </p>
        </div>
      </div>
    </section>;
}